import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/fundraising/")({
  beforeLoad: () => {
    throw redirect({ to: "/fundraising/pledges" });
  },
});
